import React from 'react'

export default function Spinner() {
  return (
    <div className="overlay">
      <div className="loader"></div>
    </div>
  )
}